<lib-dialog>
  <div class="diferido-dialog">
    <div class="dialog-header">
      <h3 class="dialog-title">Diferido</h3>
      <button
        type="button"
        class="close-btn"
        (click)="onCancel()"
        [disabled]="loading()"
        aria-label="Cerrar"
      >
        ✕
      </button>
    </div>

    @if (mostrarAlerta()) {
      <div class="alert-container">
        <lib-alert
          [type]="alertaTipo()"
          [title]="alertaTitulo()"
          [message]="alertaMensaje()"
          [autoClose]="false"
          [closeButton]="true"
          (closed)="cerrarAlerta()"
        ></lib-alert>
      </div>
    }

    <div class="dialog-content">
      <form [formGroup]="diferidoForm">
        <div class="two-column-grid">
          <div class="form-field-wrapper">
            <lib-field-label
              label="Valor Diferido"
              [required]="true"
              tooltip="Valor total a diferir. Debe ser > 0 y ≤ Total Antes Impuesto"
            />
            <lib-input
              [formControl]="valorDiferidoControl"
              type="number"
              step="0.01"
              placeholder="0.00"
              [errorMsg]="getError('valorDiferido')"
              (blur)="validarValorDiferido()"
            >
            </lib-input>
            <small class="field-hint" *ngIf="totalAntesImpuesto > 0">
              Máximo permitido: {{ formatCurrency(totalAntesImpuesto) }}
            </small>
          </div>

          <div class="form-field-wrapper">
            <lib-field-label label="Fecha Registro" tooltip="Fecha actual del sistema" />
            <lib-input
              [formControl]="fechaRegistroControl"
              placeholder="dd/MM/yyyy"
              [disabled]="true"
            >
            </lib-input>
          </div>
        </div>

        <div class="two-column-grid">
          <div class="form-field-wrapper">
            <lib-field-label
              label="Fecha Inicial"
              [required]="true"
              tooltip="Fecha de inicio del diferido. No puede ser menor a la fecha del sistema"
            />
            <lib-datepicker
              [formControl]="fechaInicialControl"
              placeholder="dd/MM/yyyy"
              (dateChange)="onFechaInicialChange($event)"
              [errorMsg]="getError('fechaInicial')"
              [minDate]="fechaMinimaInicial ?? undefined"
              [maxDate]="fechaMaxima ?? undefined"
            >
            </lib-datepicker>
          </div>

          <div class="form-field-wrapper">
            <lib-field-label
              label="Fecha Final"
              [required]="true"
              tooltip="Fecha de fin del diferido. Debe ser mayor que Fecha Inicial y no mayor a la fecha del sistema"
            />
            <lib-datepicker
              [formControl]="fechaFinalControl"
              placeholder="dd/MM/yyyy"
              (dateChange)="onFechaFinalChange($event)"
              [errorMsg]="getError('fechaFinal')"
              [minDate]="fechaMinimaFinal ?? undefined"
            >
            </lib-datepicker>
          </div>
        </div>

        <div class="two-column-grid">
          <div class="form-field-wrapper">
            <lib-field-label
              label="Días Diferidos"
              tooltip="Diferencia en días entre Fecha Final y Fecha Inicial. Máximo 5 dígitos"
            />
            <lib-input
              [formControl]="diasDiferidosControl"
              placeholder="0"
              [disabled]="true"
              [errorMsg]="getDiasErrorMsg()"
              type="text"
            >
            </lib-input>
            <small class="field-hint" *ngIf="diasDiferidosControl.value > 99999">
              Los días diferidos superan el límite máximo de 99,999 días
            </small>
          </div>

          <div class="form-field-wrapper">
            <lib-field-label
              label="Periodos a Diferir"
              tooltip="Número de periodos (meses) a diferir"
            />
            <lib-input [formControl]="periodosDiferirControl" placeholder="0" [disabled]="true">
            </lib-input>
          </div>
        </div>

        <div class="two-column-grid">
          <div class="form-field-wrapper cod-cuenta-wrapper">
            <lib-field-label
              label="Cod. Cuenta"
              [required]="true"
              tooltip="Cuenta contable destino del diferido"
            />
            <div class="cod-cuenta-input-group">
              <lib-input
                [formControl]="codCuentaControl"
                placeholder="Ej: 1234567890"
                [errorMsg]="getError('codCuenta')"
                [maxLength]="20"
                [showCharCount]="true"
                [disabled]="true"
              >
              </lib-input>
              <lib-icon
                name="Search"
                (click)="buscarCuenta()"
                class="search-icon"
                [class.disabled]="loading()"
              ></lib-icon>
            </div>
          </div>

          <div class="form-field-wrapper">
            <lib-field-label
              label="Base de Cálculo"
              [required]="true"
              tooltip="Base de cálculo para días del diferido"
            />
            <lib-select
              [formControl]="baseCalculoControl"
              [options]="baseCalculoOptions"
              placeholder="Seleccione una opción"
              [errorMsg]="getError('baseCalculo')"
            >
            </lib-select>
          </div>
        </div>

        <div class="form-field-wrapper">
          <lib-field-label label="Nombre Cuenta" tooltip="Nombre de la cuenta asociada" />
          <lib-input
            [formControl]="nombreCuentaControl"
            placeholder="Nombre de la cuenta"
            [maxLength]="100"
            [showCharCount]="true"
            [disabled]="true"
          >
          </lib-input>
        </div>

        <div class="centros-costo-section">
          <div class="section-header">
            <h4 class="section-title">Centros de Costo</h4>
          </div>

          <lib-table-input
            [(data)]="centrosCostoData"
            [config]="centrosCostoTableConfig"
            [loading]="loadingTable()"
            [readOnly]="loading()"
            (dataChange)="onCentrosCostoDataChange($event)"
            (cellAction)="onCentroCostoAction($event)"
            (action)="onCentroCostoAction($event)"
          />
        </div>
      </form>
    </div>

    <div class="dialog-footer">
      <div class="actions">
        <lib-button variant="secondary" type="button" [disabled]="loading()" (clicked)="onCancel()">
          Cancelar
        </lib-button>
        <lib-button
          variant="primary"
          type="button"
          [disabled]="loading() || !isFormularioValido()"
          (clicked)="onSave()"
        >
          {{ loading() ? 'Procesando...' : 'Aceptar' }}
        </lib-button>
      </div>
    </div>
  </div>
</lib-dialog>
